/* RESPONSIBLE TEAM: team-inbox-management */

/**
 * Validates team assignment limit value
 * @param limit - The assignment limit value to validate (can be null, undefined, empty string, or number)
 * @returns true if valid, false otherwise
 *
 * Valid values:
 * - null, undefined, or empty string (means no limit)
 * - Numbers between 1 and 999 (inclusive)
 *
 * Invalid values:
 * - 0
 * - Negative numbers
 * - Numbers greater than 999
 */
export function isValidAssignmentLimit(limit: number | null | undefined | string): boolean {
  if (limit === null || limit === undefined || limit === '') {
    return true; // null/empty is valid (means no limit)
  }

  let numLimit = typeof limit === 'string' ? parseInt(limit, 10) : limit;

  if (isNaN(numLimit)) {
    return false;
  }

  return numLimit >= 1 && numLimit <= 999;
}
